import styled from 'styled-components';

export const StyledAlert = styled.div`
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};
  padding: 12px 0;
  margin: 0 12px;
`;

export const StyledThumbnail = styled.img`
  width: 66px;
  height: 50px;
`;

export const AlertContent = styled.div`
  padding-left: 18px;
  overflow: hidden;
`;
